import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  Paper,
  CircularProgress,
  DatePicker,
  Divider,
} from 'material-ui';


import {
  PrimaryButton,
  LoadingDialog,
  AlertDialog,
  AlertDialogOneButton,
} from 'imports/DesignImports';

const styles = {
  paper: {
    display: 'flex',
    padding: '1.5em',
    margin: '0.5em',
    marginBottom: '1em',
    color: '#212F55',
    fontFamily: 'Lato',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FBFBFB',
    borderRadius: '0',
  },
  tutorialTitle: {
    fontWeight: '700',
    fontSize: '1em'
  },
  saveButton: {
    border: '1px solid rgb(91, 204, 182)',
    backgroundColor: 'rgb(91, 204, 182)',
    color: '#ffffff',
    width: '20em'
  },
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1em'
  },
  buttonsSpace:{
    marginLeft: '5px',
    marginRight: '10px'
  },
  inputContainer: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  dateInput: {
    cursor: 'pointer',
    marginLeft: '1em',
  }
}

class PortfolioSetupView extends Component {
  constructor(props){
    super(props);
    this.state = {
      selected: 0,
      deadlines: [],
      error: false,
      loading: true,
      postulationDeadline: null,
      selectionDeadline: null,
      filesDeadline: null,
      message: "",
      loadingDialog: false,
      alertDialog: false,
      alertDialogOneButton: false,
      dateNow: new Date(Date.now),
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    }
  }

  componentDidMount(){
    this.getDeadlines();
  }

  render() {
    console.log(this.props);
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los deadlines. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div style={styles.pageContainer}>
      <div>
        <h1>Setup etapa portafolio de innovación</h1>
        <p>
          {this.props.done ?
          'Estas son las fechas límite que se fijaron para el proceso' :
          'Antes de empezar la etapa de portafolio de innovación debes planificar la fecha límite para cada una de las etapas.'
        }
        </p>
        <Divider />
      </div>
      <Paper zDepth={1} style={styles.paper}>
        <div style={{width: '30%'}}><h4 style={styles.tutorialTitle}>Paso 1: Postulación de Proyectos</h4></div>
        <div style={styles.inputContainer}>
          <div style={styles.dateContainer}>
            <div style={{width: '15%'}}>Inicio: </div>
            <DatePicker
              inputStyle={styles.dateInput}
              container="inline"
              mode="landscape"
              disabled={this.props.done}
              onChange={(event, date)=>{this.updateDate(date, "postulationInitial")}}
              minDate={this.state.dateNow}
              value={this.state.postulationInitial}
              dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
            />
          </div>
          <div style={styles.dateContainer}>
            <div style={{width: '15%'}}>Fin: </div>
            <DatePicker
              inputStyle={styles.dateInput}
              container="inline"
              mode="landscape"
              disabled={this.props.done}
              onChange={(event, date)=>{this.updateDate(date, "postulationEnd")}}
              minDate={this.state.postulationInitial}
              value={this.state.postulationEnd}
              dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
            />
          </div>
        </div>
        <p style={{width: '40%'}}><b>En esta etapa se hará un llamado a los proyectos de innovación que quieran postular.</b><br/><div className='p2'>Te sugerimos 3 semanas</div></p>
      </Paper>
      <Paper zDepth={1} style={styles.paper}>
        <div style={{width: '30%'}}><h4 style={styles.tutorialTitle}>Paso 2: Selección de Proyectos</h4></div>
        <div style={styles.inputContainer}>
          <div style={styles.dateContainer}>
            <div style={{width: '15%'}}>Inicio: </div>
            <DatePicker
              inputStyle={styles.dateInput}
              container="inline"
              mode="landscape"
              disabled={this.props.done}
              onChange={(event, date)=>{this.updateDate(date, "selectionInitial")}}
              minDate={this.state.postulationEnd}
              value={this.state.selectionInitial}
              dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
            />
          </div>
          <div style={styles.dateContainer}>
            <div style={{width: '15%'}}>Fin: </div>
            <DatePicker
              inputStyle={styles.dateInput}
              container="inline"
              mode="landscape"
              disabled={this.props.done}
              onChange={(event, date)=>{this.updateDate(date, "selectionEnd")}}
              minDate={this.state.selectionInitial}
              value={this.state.selectionEnd}
              dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
            />
          </div>
        </div>
        <p style={{width: '40%'}}><b>En esta etapa INNSPIRAL y el Gerente de Innovación deberán evaluar y seleccionar los proyectos postulados.</b><br/><div className='p2'>Te sugerimos 2 semanas</div></p>
        </Paper>
        <Paper zDepth={1} style={styles.paper}>
          <div style={{width: '30%'}}><h4 style={styles.tutorialTitle}>Paso 3: Fichas de Proyectos</h4></div>
          <div style={styles.inputContainer}>
            <div style={styles.dateContainer}>
              <div style={{width: '15%'}}>Inicio: </div>
              <DatePicker
                inputStyle={styles.dateInput}
                container="inline"
                mode="landscape"
                disabled={this.props.done}
                onChange={(event, date)=>{this.updateDate(date, "filesInitial")}}
                minDate={this.state.selectionEnd}
                value={this.state.filesInitial}
                dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
              />
            </div>
            <div style={styles.dateContainer}>
              <div style={{width: '15%'}}>Fin: </div>
              <DatePicker
                inputStyle={styles.dateInput}
                container="inline"
                mode="landscape"
                disabled={this.props.done}
                onChange={(event, date)=>{this.updateDate(date, "filesEnd")}}
                minDate={this.state.filesInitial}
                value={this.state.filesEnd}
                dialogContainerStyle={{backgroundColor: '#FFFFFF'}}
              />
            </div>
          </div>
          <p style={{width: '40%'}}><b>En esta etapa cada líder de proyecto deberá completar la ficha de su proyecto.</b><br/><div className='p2'>Te sugerimos 8 semanas</div></p>
        </Paper>
        {!this.props.done &&
          <div style={styles.saveButtonContainer}>
            <div style={{...styles.buttonsSpace}}>
              <PrimaryButton label="Definir Fechas" onClick={() => {this.postDeadlines()}} />
            </div>
          </div>
        }
      {this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento"/> : null}
      {this.state.alertDialog ?
        <AlertDialog
          title='¡Muy bien!'
          message="Has completado el setup inicial del portafolio de proyectos. ¿Quieres continuar o hacer cambios?"
          acceptLabel='Continuar'
          cancelLabel='Hacer cambios'
          confirm={() => this.props.history.push('/portfolio')}
          cancel={() => this.setState({alertDialog: false})}/> : null}
      {this.state.alertDialogOneButton ?
        <AlertDialogOneButton
          title='¡Error!'
          message="No se pudieron guardar las fechas, intenta nuevamente."
          acceptLabel='Aceptar'
          confirm={() => this.setState({alertDialog: false})}/> : null}
      </div>
    );
  }

  getDeadlineByStep(step){
    return this.state.deadlines.find((obj)=>{return obj.step === step})
  }

  setDefaultDates(){
    let postulation = this.getDeadlineByStep("postulation");
    let selection = this.getDeadlineByStep("selection");
    let files = this.getDeadlineByStep("files");

    let postulationInitial = new Date(Date.now());

    let postulationEnd = new Date(Date.now());
    postulationEnd.setDate(postulationInitial.getDate() + 7);

    let selectionInitial = new Date(Date.now());
    selectionInitial.setDate(postulationInitial.getDate() + 7);

    let selectionEnd = new Date(Date.now());
    selectionEnd.setDate(selectionInitial.getDate() + 14);

    let filesInitial = new Date(Date.now());
    filesInitial.setDate(selectionInitial.getDate() + 7);

    let filesEnd = new Date(Date.now());
    filesEnd.setDate(filesInitial.getDate() + 21);

    this.setState({
      postulationInitial: postulation ? new Date(postulation.start_date) : postulationInitial,
      postulationEnd: postulation ? new Date(postulation.deadline) : postulationEnd,
      selectionInitial: selection ? new Date(selection.start_date) : selectionInitial,
      selectionEnd: selection ? new Date(selection.deadline) : selectionEnd,
      filesInitial: files ? new Date(files.start_date) : filesInitial,
      filesEnd: files ? new Date(files.deadline) : filesEnd,
    });
  }

  updateDate = (date, key) => {
    this.setState({[key]: date});
  }

  getDeadlines = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.portfolioDeadlines(this.state.user.company_id))
      .then((response) => {
        console.log(response);
        this.setState({
          error: false,
          loading: false,
          deadlines: response.data.deadlines
        }, ()=> {this.setDefaultDates()});
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          error: true,
          loading: false
        });
      });
  }

  postDeadlines = () => {
    this.setState({loadingDialog: true})
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token " + this.state.token}
    });
    var data = [];
    let postulationStep = {
      start_date: this.state.postulationInitial,
      deadline: this.state.postulationEnd,
      step: 'postulation',
    }
    let selectionStep = {
      start_date: this.state.selectionInitial,
      deadline: this.state.selectionEnd,
      step: 'selection',
    }
    let filesStep = {
      start_date: this.state.filesInitial,
      deadline: this.state.filesEnd,
      step: 'files',
    }
    data.push(postulationStep);
    data.push(selectionStep);
    data.push(filesStep);
    var postDeadlines = connection.post(routes.portfolioDeadlines(this.state.user.company_id), data)
    var advanceStage = connection.patch(routes.nextStage(this.state.user.company_id))
    Promise.all([postDeadlines, advanceStage])
    .then((responses) => {
      this.props.cookies.set('current_stage', JSON.stringify(responses[1].data), { path: '/' });
      this.setState({
        loadingDialog: false,
        alertDialog: true,
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        alertDialogOneButton: true,
        loadingDialog: false,
      })
    });
  }
}

export default withCookies(withRouter(PortfolioSetupView));



// WEBPACK FOOTER //
// ./src/views/setup/PortfolioSetupView.js